import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class PautaService extends Service {
    async gerarResumoPauta(idSessao, cpfSignatario, sistemaOrigem) {
        return this.getPautaApi().gerarResumoPauta(idSessao, cpfSignatario, sistemaOrigem);
    }
}

export default PautaService;
